"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SnapWalletAdapter = void 0;
const web3_js_1 = require("@solana/web3.js");
const wallet_adapter_base_1 = require("@solana/wallet-adapter-base");
// The current version of the snap package
// Automatically generated when running yarn or yarn build
// The snap id should probably have a default imported like this too
const version_1 = require("./version");
const icon_1 = __importDefault(require("./icon"));
class SnapWalletAdapter extends wallet_adapter_base_1.BaseMessageSignerWalletAdapter {
    constructor(snapId) {
        var _a;
        super();
        this.name = "Connect by Drift";
        this.url = "https://github.com/drift-labs/snap-solana";
        this.snapId = "npm:@drift-labs/snap-solana";
        this.icon = icon_1.default;
        this.versionToUse = version_1.SNAP_VERSION;
        /**
         * Connects to a metamask snap
         *
         * @param forceUpdate - optional, forces the snap to be reinstalled on each connect if true
         *
         */
        this.connect = async (forceUpdate) => {
            var _a;
            if (!window.ethereum) {
                throw new Error("Metamask not detected");
            }
            const installedSnaps = (await window.ethereum.request({
                method: "wallet_getSnaps",
            }));
            // If snap is not installed or version is outdated, ask to (re)install it
            if (!installedSnaps[this.snapId] ||
                ((_a = installedSnaps[this.snapId]) === null || _a === void 0 ? void 0 : _a.version) !== this.versionToUse ||
                forceUpdate) {
                await window.ethereum.request({
                    method: "wallet_requestSnaps",
                    params: {
                        [this.snapId]: {
                            version: this.versionToUse,
                        },
                    },
                });
            }
            const publicKey = new web3_js_1.PublicKey(await window.ethereum.request({
                method: "wallet_invokeSnap",
                params: {
                    snapId: this.snapId,
                    request: {
                        method: "getPublicKey",
                    },
                },
            }));
            this.publicKey = publicKey;
            this.emit("connect", publicKey);
        };
        this.disconnect = async () => {
            // Not sure if there's much for us to do here?
            this.publicKey = undefined;
            this.emit("disconnect");
        };
        // Only allow changing the snap id on localhost
        if (snapId &&
            typeof window !== "undefined" &&
            ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hostname) === "localhost") {
            this.snapId = snapId;
        }
        this.checkIfSnapsAreSupported();
    }
    async checkIfSnapsAreSupported() {
        var _a, _b;
        if (typeof window !== "undefined" && ((_a = window === null || window === void 0 ? void 0 : window.ethereum) === null || _a === void 0 ? void 0 : _a.isMetaMask)) {
            try {
                const installedSnaps = (await window.ethereum.request({
                    method: "wallet_getSnaps",
                }));
                if (!installedSnaps[this.snapId] ||
                    ((_b = installedSnaps[this.snapId]) === null || _b === void 0 ? void 0 : _b.version) !== this.versionToUse) {
                    this.readyState = wallet_adapter_base_1.WalletReadyState.Loadable;
                }
                else {
                    this.readyState = wallet_adapter_base_1.WalletReadyState.Installed;
                }
            }
            catch (err) {
                this.readyState = wallet_adapter_base_1.WalletReadyState.Unsupported;
            }
        }
        else {
            this.readyState = wallet_adapter_base_1.WalletReadyState.NotDetected;
        }
        this.emit("readyStateChange", this.readyState);
    }
    async signMessage(message) {
        var _a;
        const rpcRequestObject = {
            method: "signMessage",
            params: {
                message,
            },
        };
        const results = (await window.ethereum.request({
            method: "wallet_invokeSnap",
            params: {
                snapId: this.snapId,
                request: rpcRequestObject,
            },
        }));
        return Buffer.from((_a = results === null || results === void 0 ? void 0 : results.message) === null || _a === void 0 ? void 0 : _a.data);
    }
    // @ts-ignore
    async signTransaction(tx) {
        var _a, _b;
        const isVersionedTx = (0, wallet_adapter_base_1.isVersionedTransaction)(tx);
        const serializeConfig = isVersionedTx
            ? undefined
            : {
                requireAllSignatures: false,
                verifySignatures: false,
            };
        const serialized = tx.serialize(serializeConfig);
        const rpcRequestObject = {
            method: "signTransaction",
            params: {
                transaction: serialized,
                isVersionedTransaction: isVersionedTx,
                serializeConfig,
            },
        };
        const results = (await window.ethereum.request({
            method: "wallet_invokeSnap",
            params: {
                snapId: this.snapId,
                request: rpcRequestObject,
            },
        }));
        let returnTx;
        // De-serialize results:
        if (isVersionedTx) {
            returnTx = web3_js_1.VersionedTransaction.deserialize(Buffer.from((_a = results === null || results === void 0 ? void 0 : results.transaction) === null || _a === void 0 ? void 0 : _a.data));
        }
        else {
            returnTx = web3_js_1.Transaction.from(Buffer.from((_b = results === null || results === void 0 ? void 0 : results.transaction) === null || _b === void 0 ? void 0 : _b.data));
        }
        return returnTx;
    }
    // @ts-ignore
    async signAllTransactions(txes) {
        const serialized = txes.map((tx) => {
            const isVersionedTx = (0, wallet_adapter_base_1.isVersionedTransaction)(tx);
            const serializeConfig = isVersionedTx
                ? undefined
                : {
                    requireAllSignatures: false,
                    verifySignatures: false,
                };
            const serializedTx = tx.serialize(serializeConfig);
            return {
                isVersionedTransaction: isVersionedTx,
                transaction: serializedTx,
                serializeConfig,
            };
        });
        const rpcRequestObject = {
            method: "signAllTransactions",
            params: {
                transactions: serialized,
            },
        };
        const results = (await window.ethereum.request({
            method: "wallet_invokeSnap",
            params: {
                snapId: this.snapId,
                request: rpcRequestObject,
            },
        }));
        // De-serialize results:
        const signedTxes = results.map((result, index) => {
            var _a, _b;
            if ((0, wallet_adapter_base_1.isVersionedTransaction)(txes[index])) {
                return web3_js_1.VersionedTransaction.deserialize(Buffer.from((_a = result === null || result === void 0 ? void 0 : result.transaction) === null || _a === void 0 ? void 0 : _a.data));
            }
            else {
                return web3_js_1.Transaction.from(Buffer.from((_b = result === null || result === void 0 ? void 0 : result.transaction) === null || _b === void 0 ? void 0 : _b.data));
            }
        });
        return signedTxes;
    }
}
exports.SnapWalletAdapter = SnapWalletAdapter;
SnapWalletAdapter.defaultVersion = version_1.SNAP_VERSION;
SnapWalletAdapter.icon = icon_1.default;
